/**
 * store.js — giỏ hàng và danh sách yêu thích DEMO, lưu trong localStorage.
 *
 * Chỉ phục vụ bản HTML tĩnh: lên WooCommerce thì giỏ hàng là WC()->cart (cart fragments
 * cập nhật số đếm + mini cart), yêu thích là plugin wishlist — xoá file này cùng catalog.js.
 *
 * Lưu NGUYÊN bản chụp sản phẩm (tên, giá, ảnh…) chứ không chỉ id: trang giỏ hàng vẽ lại
 * được ngay cả khi sản phẩm không có trong catalog mẫu (tức là đọc từ data-* của card).
 * Giá lưu là số nguyên VND, chỉ format lúc in.
 *
 * Lần truy cập đầu tiên, giỏ có sẵn 2 chai và yêu thích có sẵn 3 chai — đúng như ảnh
 * trong guideline — để duyệt bản tĩnh không phải tự thêm. Xoá khoá wb_seeded để làm lại.
 *
 * Mọi thay đổi phát sự kiện `wb:cart` / `wb:wishlist` trên document; các module giao
 * diện (cart.js, wishlist.js, trang giỏ hàng…) nghe sự kiện đó để vẽ lại.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var KEY_CART = 'wb_cart';
    var KEY_WISH = 'wb_wishlist';
    var KEY_SEEDED = 'wb_seeded';
    var MAX_QTY = 24; // guideline: tối đa 24 chai mỗi dòng

    // localStorage có thể ném lỗi (Safari riêng tư, bị chặn cookie) — khi đó chạy
    // như giỏ hàng chỉ sống trong phiên trang, không làm hỏng giao diện.
    var memory = {};

    function read(key) {
        try {
            var raw = window.localStorage.getItem(key);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return memory[key] || null;
        }
    }

    function write(key, value) {
        memory[key] = value;
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            /* giữ trong bộ nhớ */
        }
    }

    function emit(name, detail) {
        var event;
        try {
            event = new CustomEvent('wb:' + name, { detail: detail });
        } catch (e) {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent('wb:' + name, false, false, detail);
        }
        document.dispatchEvent(event);
    }

    function money(value) {
        return Math.round(Number(value) || 0).toLocaleString('vi-VN') + '₫';
    }

    function clampQty(qty) {
        qty = parseInt(qty, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        return Math.min(qty, MAX_QTY);
    }

    // Ghép bản chụp sản phẩm: catalog mẫu (nếu có) + data-* trên phần tử [data-product]
    function product(id, el) {
        var base = (window.WBCatalog && id && window.WBCatalog.get(id)) || {};
        var data = el && el.dataset ? el.dataset : {};
        var snap = {};
        var key;

        for (key in base) {
            if (Object.prototype.hasOwnProperty.call(base, key)) snap[key] = base[key];
        }

        snap.id = id || data.productId || base.id;
        if (data.name) snap.name = data.name;
        if (data.price) snap.price = Number(data.price);
        if (data.regularPrice) snap.regularPrice = Number(data.regularPrice);
        if (data.image) snap.image = data.image;
        if (data.meta) snap.meta = data.meta;
        if (data.flag) snap.flag = data.flag;
        if (data.url) snap.url = data.url;
        if (data.variant) snap.variant = data.variant;

        if (!snap.image) snap.image = 'images/products/bottle.png';
        if (!snap.url) snap.url = 'single-product.html';
        return snap.id && snap.name ? snap : null;
    }

    // Dòng giỏ hàng phân biệt theo id + dung tích (cùng chai 750ml và 1.5L là 2 dòng)
    function lineKey(item) {
        return item.id + (item.variant ? '|' + item.variant : '');
    }

    function seed() {
        if (read(KEY_SEEDED) || !window.WBCatalog) return;
        write(KEY_SEEDED, 1);
        if (read(KEY_CART) || read(KEY_WISH)) return;

        var cat = window.WBCatalog;
        var cart = [];
        var margaux = cat.get('chateau-margaux');
        var barolo = cat.get('barolo-riserva');
        if (margaux) cart.push(Object.assign({}, margaux, { qty: 2 }));
        if (barolo) cart.push(Object.assign({}, barolo, { qty: 1 }));
        write(KEY_CART, cart);

        // savedPrice: giá lúc bấm lưu — trang yêu thích so với giá hiện tại để báo "giảm từ khi lưu"
        var wish = [];
        if (margaux) wish.push(Object.assign({}, margaux, { savedPrice: 1590000 }));
        if (barolo) wish.push(Object.assign({}, barolo, { savedPrice: barolo.price }));
        var penfolds = cat.get('penfolds-bin-389');
        if (penfolds) wish.push(Object.assign({}, penfolds, { savedPrice: penfolds.price }));
        write(KEY_WISH, wish);
    }

    // Ảnh lấy lại theo catalog mỗi lần đọc: bản chụp cũ trong localStorage có thể còn đường
    // dẫn ảnh đã đổi (vd bottle.png dùng chung trước đây). Ảnh không phải dữ liệu khách nhập
    // nên luôn theo catalog; sản phẩm ngoài catalog (thẻ quà tặng) giữ nguyên ảnh đã lưu.
    function freshImages(items) {
        if (!window.WBCatalog) return items;
        items.forEach(function (item) {
            var live = window.WBCatalog.get(item.id);
            if (live && live.image) item.image = live.image;
        });
        return items;
    }

    function cartItems() {
        seed();
        return freshImages(read(KEY_CART) || []);
    }

    function saveCart(items, reason) {
        write(KEY_CART, items);
        emit('cart', { items: items, reason: reason });
    }

    function wishItems() {
        seed();
        return freshImages(read(KEY_WISH) || []);
    }

    function saveWish(items, reason, item) {
        write(KEY_WISH, items);
        emit('wishlist', { items: items, reason: reason, item: item });
    }

    window.WBStore = {
        money: money,
        product: product,
        maxQty: MAX_QTY,

        cart: {
            items: cartItems,
            count: function () {
                return cartItems().reduce(function (sum, item) {
                    return sum + item.qty;
                }, 0);
            },
            subtotal: function () {
                return cartItems().reduce(function (sum, item) {
                    return sum + item.price * item.qty;
                }, 0);
            },
            // Tổng tiết kiệm so với giá gốc — thanh hành động giỏ hàng mobile hiện dòng này
            savings: function () {
                return cartItems().reduce(function (sum, item) {
                    return sum + (item.regularPrice > item.price ? (item.regularPrice - item.price) * item.qty : 0);
                }, 0);
            },
            add: function (snap, qty) {
                if (!snap) return;
                var items = cartItems();
                var key = lineKey(snap);
                var found = null;
                items.forEach(function (item) {
                    if (lineKey(item) === key) found = item;
                });
                if (found) {
                    found.qty = clampQty(found.qty + clampQty(qty));
                } else {
                    items.push(Object.assign({}, snap, { qty: clampQty(qty) }));
                }
                saveCart(items, 'add');
            },
            setQty: function (key, qty) {
                var items = cartItems();
                items.forEach(function (item) {
                    if (lineKey(item) === key) item.qty = clampQty(qty);
                });
                saveCart(items, 'qty');
            },
            remove: function (key) {
                saveCart(
                    cartItems().filter(function (item) {
                        return lineKey(item) !== key;
                    }),
                    'remove'
                );
            },
            clear: function () {
                saveCart([], 'clear');
            },
            key: lineKey
        },

        wishlist: {
            items: wishItems,
            count: function () {
                return wishItems().length;
            },
            has: function (id) {
                return wishItems().some(function (item) {
                    return item.id === id;
                });
            },
            toggle: function (snap) {
                if (!snap) return false;
                var items = wishItems();
                var exists = items.some(function (item) {
                    return item.id === snap.id;
                });
                if (exists) {
                    saveWish(
                        items.filter(function (item) {
                            return item.id !== snap.id;
                        }),
                        'remove',
                        snap
                    );
                    return false;
                }
                items.push(Object.assign({}, snap, { savedPrice: snap.price }));
                saveWish(items, 'add', snap);
                return true;
            },
            remove: function (id) {
                saveWish(
                    wishItems().filter(function (item) {
                        return item.id !== id;
                    }),
                    'remove'
                );
            },
            clear: function () {
                saveWish([], 'clear');
            }
        }
    };
})();
